import { render, staticRenderFns } from "./FormularioItem.vue?vue&type=template&id=0bef03e6"
import script from "./FormularioItem.vue?vue&type=script&lang=js"
export * from "./FormularioItem.vue?vue&type=script&lang=js"
import style0 from "./FormularioItem.vue?vue&type=style&index=0&id=0bef03e6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports